import React, { useState } from "react";
import styles from "./TemplateDownload.module.css";
import { handleDownload } from "./TemplateDownload.utils";
import CustomButton from "../../../pages/reusable_components/custom_button_component/Button";
import { Col } from "react-bootstrap";

export interface TemplateDownloadProps {
    title: string;
    extension: string;
    endpoint: string;
    params: Record<string, string | number | string[] | number[]>;
    filename: string;
    disabled?: boolean;
    showButton?: boolean;
    onHide?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const TemplateDownload: React.FC<TemplateDownloadProps> = ({
    title,
    extension,
    endpoint,
    params,
    filename,
    disabled = false,
    showButton = false,
    onHide
}) => {
    const onDownloadClick = async (e: React.MouseEvent) => {
        e.preventDefault(); // Prevent actual navigation
        if (!disabled) {
            await handleDownload(endpoint, params, filename, extension, setExcelFileDownloading);
        }
    };

    const [excelFileDownloading, setExcelFileDownloading] = useState(false)

    return (
        showButton 
        ?
        (<>
            <Col>
                <CustomButton
                    content="Download"
                    progress={excelFileDownloading}
                    disabled={disabled}
                    onclick={onDownloadClick}
                    
                />
            </Col>
            <Col className="d-flex justify-content-end">
                <CustomButton
                    content="Cancel"                                
                    onclick={onHide ?? (() => {})}
                />
            </Col>
        </>)
        :
        <div className={styles.templateDownloadText}>
            <a
                href="#"
                onClick={onDownloadClick}
                className={disabled ? styles.disabledLink : styles.activeLink}
            >
                {title}
            </a>
        </div>
    );
};

export default TemplateDownload;
